var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Horizontal Bar Chart"}},[_c('app-echart-bar',{attrs:{"option-data":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }